/**
 * Route Guard Component
 * Guards protected routes against unauthenticated sessions.
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { storageService } from '../../infrastructure/storage/storageService';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isAuthenticated = !!storageService.get('xservices_authenticated');

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
